import { render, staticRenderFns } from "./Listings.vue?vue&type=template&id=563c071e&scoped=true&"
import script from "./Listings.vue?vue&type=script&lang=js&"
export * from "./Listings.vue?vue&type=script&lang=js&"
import style0 from "./Listings.vue?vue&type=style&index=0&id=563c071e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c071e",
  null
  
)

export default component.exports